import Icons from 'assets/icons'
import icons from 'assets/icons'
import DefaultSelect from 'components/formElements/DefaultSelect'
import Spinner from 'components/loader/Spinner'
import ApprovalContent from 'components/modalContent/ApprovalContent'
import { useFileReader } from 'hooks/useFileReader'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { closeApprovalModal, openApprovalModal } from 'redux/features/general/generalSlice'
import { setTask } from 'redux/features/taskDetail/taskDetailSlice'
import { themeColors } from 'utils/Constants'
import Button from '../formElements/Button'

const Comment = () => {
	const { taskDetail, general } = useSelector((state) => state)
	const { ticketComments } = taskDetail.task
	const { approvalModal } = general
	const { showToast } = useToast()
	const { taskId } = useParams()
	const dispatch = useDispatch()
	const [commentSort, setCommentSort] = useState({ label: 'En Yeni Yorum', value: 1 })
	const [saveComment, saveCommentLoading] = useRequest()
	const [getTaskDetail] = useRequest()
	const [deleteCommentRequest] = useRequest()
	const [sendMessageData, setSendMessageData] = useState({
		message: '',
		files: [],
	})
	const [filesData, setFilesData, convert] = useFileReader()

	const onChangeFunc = async (e) => {
		if (e.target.name == 'files') {
			const files = e.target.files
			//image upload
			convert(files)
		} else {
			setSendMessageData({ ...sendMessageData, [e.target.name]: e.target.value })
		}

		// setSendMessageData({...sendMessageData, fileList : imagesData})
	}
	const commentSortOptions = [
		{ label: 'En Yeni Yorum', value: 1 },
		{ label: 'En Eski Yorum', value: 2 },
	]
	const handleCommentSortChange = (e) => {
		setCommentSort(e)
	}
	const sendMessage = () => {
		const formData = new FormData()
		filesData?.forEach((f) => {
			formData.append('FormFiles', f.file)
		})
		formData.append('TicketId', taskId)
		formData.append('Message', sendMessageData.message)
		saveComment('/Ticket/AddTicketComment', {
			method: 'POST',
			data: formData,
		}).then((res) => {
			if (res.data) {
				setSendMessageData({ message: '', files: [] })
				setFilesData([])
				getTaskDetail('/Ticket/GetTicketById', {
					method: 'GET',
					params: {
						id: taskId,
					},
				}).then((res) => {
					if (res.data.ok) {
						dispatch(setTask(res.data.result))
					}
				})
			}
		})
	}
	const deleteFile = (key) => {
		setFilesData((prev) => [...prev.filter((e, i) => i != key)])
	}
	const handleCloseApprovalModal = async () => {
		dispatch(closeApprovalModal())
	}
	const handleSubmitApproval = () => {
		const formData = new FormData()
		formData.append('Id', approvalModal.commentId)
		deleteCommentRequest('/Ticket/DeleteTicketComment', {
			method: 'DELETE',
			data: formData,
		}).then((res) => {
			if (res.data.ok) {
				getTaskDetail('/Ticket/GetTicketById', {
					method: 'GET',
					params: {
						id: taskId,
					},
				}).then((res) => {
					if (res.data.ok) {
						dispatch(setTask(res.data.result))
						dispatch(closeApprovalModal())
						showToast('Yorum Silindi', 'success')
					}
				})
			}
		})
	}
	const deleteComment = (comment) => {
		dispatch(openApprovalModal({ open: true, content: 'Yorumu silmek istediğinize emin misiniz?', commentId: comment.id }))
	}
	return (
		<div className='comment'>
			<Dialog draggable={false} visible={approvalModal.open} onHide={handleCloseApprovalModal}>
				<ApprovalContent handleClose={handleCloseApprovalModal} handleApproved={handleSubmitApproval} />
			</Dialog>
			<div className='comment-box'>
				<textarea
					onChange={onChangeFunc}
					value={sendMessageData.message}
					className='mt-2'
					name='message'
					id=''
					cols='30'
					rows='4'
					placeholder='Bir Yorum Ekleyin.'
				/>
				<div className='comment-box-absolute'>
					<label htmlFor='file'>
						<icons.attach size={16} className='comment-box-absolute-icon' />
					</label>
					<input multiple name='files' onChange={onChangeFunc} style={{ display: 'none' }} className='' type='file' id='file' />
					{/* {handleClick,icon, disabled , className,title} */}
					<Button
						handleClick={sendMessage}
						disabled={saveCommentLoading}
						icon={saveCommentLoading ? <Spinner size={1} /> : <icons.send size={16} />}
						className='comment-box-absolute-btn'
						title={saveCommentLoading ? 'Gönderiliyor' : 'Gönder'}
					/>
				</div>
			</div>
			<div>
				{filesData.length > 0 &&
					Array.from(filesData)?.map((file, i) => (
						<div className='text-sm comment-fileList' key={i}>
							<div className='mb-2'>✔ {file?.fileName?.substring(0, 32)}</div>
							<icons.delete onClick={() => deleteFile(i)} size={21} className='comment-fileList-delete' />
						</div>
					))}
			</div>
			<div className='comment-content'>
				<div className='comment-content-top'>
					<div className='text-muted text-md'>Yorumlar</div>
					<div className='comment-content-top-right'>
						<DefaultSelect
							handleChange={handleCommentSortChange}
							value={commentSort}
							padding='.35rem'
							fontSize='.8rem'
							textColor={themeColors.success}
							backgroundColor={themeColors.successLight}
							selectOptions={commentSortOptions}
						/>
					</div>
				</div>
				<div className='comment-content-body'>
					{ticketComments?.length < 1 ? (
						<div className='heading-5'>Henüz Yorum Yapılmamış</div>
					) : (
						ticketComments
							?.slice()
							?.sort((a, b) =>
								commentSort.value == 2
									? moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
									: moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
							)
							?.map((msg, i) => (
								<div className='card mb-2 comment-content-body-card' key={i}>
									<div className='comment-content-body-card-title'>
										<div className='text-bold'>{msg.createdBy}</div>
										<div className='text-muted text-sm'>{moment(msg.createdAt).format('DD/MM/YYYY')}</div>
									</div>
									<div className='text-md'>{msg.message}</div>
									<div className='comment-content-body-card-footer'>
										<span>
											{msg?.ticketDocuments?.map((d) => (
												<a download={d.fileName} href={`data:${d.documentType};base64,${d.data}`} key={d.id} className='text-sm pr-2'>
													{d.fileName}
												</a>
											))}
										</span>
										<span>
											<Icons.delete onClick={() => deleteComment(msg)} className='comment-delete-icon' />
										</span>
									</div>
								</div>
							))
					)}
				</div>
			</div>
		</div>
	)
}

export default Comment
